import request from "@/util/axios";

export const auth_wechat_token_login_by_code = (code) => {
  const grant_type = "wechat";
  return request({
    url: "/v5/weixin-token", // /v5/weixin-token // /auth/wechat/token
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "post",
    params: { grant_type, code, type: "mp" },
  });
};

export const mall_wx_get_user_info = () => {
  return request({
    url: "/mall/wx/wx-user-get-user-info",
  });
};
